import { SiteHeader } from './SiteHeader';
import { Footer } from '../landing/Footer';

export const PageShell = ({ children, testId }) => (
  <div className="min-h-screen bg-white flex flex-col" data-testid={testId}>
    <SiteHeader />
    <main className="flex-1">{children}</main>
    <Footer />
  </div>
);

export const PageHero = ({ eyebrow, title, children }) => (
  <section className="border-b border-[#E4E4E7] bg-[#FAFAFA]">
    <div className="max-w-6xl mx-auto px-6 py-16 md:py-20">
      {eyebrow && <p className="font-mono text-xs uppercase tracking-widest text-[#0047FF] mb-4">{eyebrow}</p>}
      <h1 className="font-heading text-4xl sm:text-5xl lg:text-6xl font-bold tracking-tight text-[#09090B] max-w-3xl" data-testid="page-title">
        {title}
      </h1>
      {children && <div className="mt-6 text-base md:text-lg text-[#71717A] max-w-2xl leading-relaxed">{children}</div>}
    </div>
  </section>
);
